import { Injectable } from '@angular/core';
import { VgUtilsService } from 'vbrick-player-src/videogular/VgUtils.Service';
import { PLAYER_USER_PREFERENCE_KEY } from './PlayerUserPreferenceHandler';

@Injectable({
	providedIn: 'root'
})
export class PlayerUserPreferencesService {
	private isLocalStorageAvailable = true;

	constructor(private readonly vgUtils: VgUtilsService) {}


	public init(disableUserPreferences: boolean): void {
		this.isLocalStorageAvailable = !disableUserPreferences && this.vgUtils.supportsLocalStorage();

		if (!this.isLocalStorageAvailable) {
			console.warn('Either UserPreferences is disabled or Local storage is not available. User preferences will not be saved.');
		}
	}

	public get isUserPreferencesAvailable(): boolean {
		return this.isLocalStorageAvailable;
	}

	public getPreference<T>(key: PLAYER_USER_PREFERENCE_KEY): T {
		if (!this.isUserPreferencesAvailable) {
			return null;
		}
		try {
			return JSON.parse(localStorage.getItem(key));
		}
		catch (e) {
			console.error(e);
			return null;
		}
	}
	public setPreference<T>(key: PLAYER_USER_PREFERENCE_KEY, value: T): void {
		if (!this.isUserPreferencesAvailable) {
			return;
		}

		if (value == null) {
			localStorage.removeItem(key); // Remove key if value is undefined
			return;
		}

		localStorage.setItem(key, JSON.stringify(value));
	}
}
